import React from 'react';
import CreateNoteDialog from './CreateNoteDialog';
import CreateAssignmentDialog from './CreateAssignmentDialog';
import CompleteAssignmentDialog from './CompleteAssignmentDialog';
import DeleteEventDialog from './DeleteEventDialog';
import EventActionDialog from './EventActionDialog';
import EditEventDialog from './EditEventDialog';

/**
 * Container component for all history-related dialogs
 * Consolidates dialog rendering to reduce clutter in main component
 * Note: Settings dialog is now centralized in UnifiedSettingsDialog
 */
export default function HistoryDialogs({
  dialogs,
  formState,
  loading,
  allEvents,
  openAssignments,
  handlers,
  onClose
}) {
  return (
    <>
      <CreateNoteDialog
        open={dialogs.createNote}
        noteText={formState.noteText}
        onNoteTextChange={handlers.onNoteTextChange}
        onClose={onClose.createNote}
        onSave={handlers.onCreateNote}
        loading={loading}
      />

      <CreateAssignmentDialog
        open={dialogs.createAssignment}
        description={formState.newAssignmentDesc}
        onDescriptionChange={handlers.onAssignmentDescChange}
        onClose={onClose.createAssignment}
        onCreate={handlers.onCreateAssignment}
        loading={loading}
      />

      <CompleteAssignmentDialog
        open={dialogs.completeAssignment}
        openAssignments={openAssignments}
        selectedAssignment={formState.selectedAssignment}
        onSelectAssignment={handlers.onSelectAssignment}
        onClose={onClose.completeAssignment}
        onComplete={handlers.onCompleteAssignment}
        loading={loading}
      />

      <DeleteEventDialog
        open={dialogs.deleteEvent}
        event={formState.eventToDelete}
        allEvents={allEvents}
        onClose={onClose.deleteEvent}
        onConfirm={handlers.onDeleteEvent}
        loading={loading}
      />

      <EventActionDialog
        open={dialogs.eventAction}
        event={formState.selectedEvent}
        allEvents={allEvents}
        onClose={onClose.eventAction}
        onEdit={handlers.onEditClick}
        onDelete={handlers.onDeleteFromAction}
        onCreateStatement={handlers.onCreateStatement}
      />

      <EditEventDialog
        open={dialogs.editEvent}
        event={formState.selectedEvent}
        description={formState.editDescription}
        onDescriptionChange={handlers.onEditDescChange}
        onClose={onClose.editEvent}
        onSave={handlers.onEditSave}
        loading={loading}
      />
    </>
  );
}
